import ArticleLayout from '../article/components/ArticleLayout';
import { articles } from '@/mocks/articles';

export default function PorownaniePage() {
  return <ArticleLayout article={articles[4]} />;
}